/* src/app/components/intro/intro.component.scss */
.service-box .mat-icon {
  transform: scale(2);
  color: #380415;
  margin-bottom: 1rem;
}
.service-box h1 {
  color: #380415;
  font-weight: 600;
  font-size: 2em;
}
.service-box p {
  font-size: 0.9rem;
}
.chamada {
  display: block;
  background: rgba(0, 0, 0, 0.2);
  text-align: center;
  padding: 5rem;
  color: white;
  font-size: 2rem;
}
#compartilhe {
  display: block;
}
/*# sourceMappingURL=intro.component-7YBHW3IZ.css.map */
